import React from 'react';
import './../../../../styles/bb-icons/_bettedon.scss';

import {
    BETTED_ON_CSS_CLASS_NAME,
} from '../constants';

const BettedOnTick = () => {
    return (
        <span className={BETTED_ON_CSS_CLASS_NAME}></span>
    );
};
export default BettedOnTick;
